import React, { useContext, useEffect, useState } from 'react';
import Axios from '../../_services/caller.service';
import styles from './CabBySubscriptions.module.scss';
import NavContext from '../../context/NavContext';

const CabBySubscriptions = () => {
  const [cabines, setCabines] = useState([]);
  const [grouped, setGrouped] = useState({});
  const [loading, setLoading] = useState(true);
  const {
    ownerId,
   
  } = useContext(NavContext);

  useEffect(() => {
    Axios.get(`/allCabinesWithSubscriptions/${ownerId}`)
      .then((response) => {
        const data = response.data.data || [];
        setCabines(data);
        setGrouped(groupBySubscription(data));
        setLoading(false);
        console.log("Cabines récupérées :", response.data.data);
        

      })
      .catch(function (error) {
        console.log(error);
                setLoading(false);
      });
  }, []);





  const groupBySubscription = (list) => {
    const map = {};
    list.forEach(item => {
      const subId = item.subscription_id || 'aucun';
      if (!map[subId]) {
        map[subId] = {
          name: item.subscription_name || 'Sans abonnement',
          variation: item.subscription_variation || '',
          cabines: []
        };
      }
      map[subId].cabines.push(item);
    });
    return map;
  };

  if (loading) return <p>Chargement...</p>;

  return (
    <div className={styles.container}>
  {Object.entries(grouped).map(([subId, group]) => (
    <div key={subId} className={styles.subscriptionBlock}>
      <h3 className={styles.subscriptionTitle}>
        Abonnement #{subId !== 'aucun' ? subId : 'Non défini'} — <strong>{group.name}</strong>{' '}
        {group.variation && <span className={styles.variation}>({group.variation})</span>}
      </h3>

      {group.cabines.length > 0 ? (
        <ul className={styles.cabineList}>
          {group.cabines.map(cab => (
            <li key={cab.cabine_id} className={styles.cabineItem}>
              <strong>{cab.cabname}</strong> — {cab.cabtype} ({cab.machine})
            </li>
          ))}
        </ul>
      ) : (
        <p className={styles.emptyMessage}>Aucune cabine liée</p>
      )}
    </div>
  ))}
</div>

  );
};

export default CabBySubscriptions;
